function observeParallaxAdContainers() {
    const containers = document.querySelectorAll<HTMLElement>(".parallax-ad-container")

    if (containers.length === 0) {
        return
    }

    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.classList.add("in-view")
                } else {
                    entry.target.classList.remove("in-view")
                }
            }
        },
        { threshold: 0.25 },
    )

    for (const container of containers) {
        observer.observe(container)
    }
}

window.addEventListener("parallax-ad.inserted", () => {
    observeParallaxAdContainers()
})
